import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[intizerOnly]',
  standalone: true
})
export class IntizerOnlyDirective {
  private enabled = false;

  constructor(private el: ElementRef) { }

  // Accept presence-based attribute or boolean binding
  @Input()
  set intizerOnly(value: any) {
    this.enabled = value === '' || value === true || value === 'true';
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (!this.enabled) { return; }
    const e = event;

    // Allow: backspace, delete, tab, escape, enter
    const allowedKeys = [46, 8, 9, 27, 13];
    if (allowedKeys.indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A/C/X
      (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode === 67 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      return;
    }

    // Ensure that it is a number (no decimals) and stop the keypress
    const isNumber = (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105);
    if (e.shiftKey || !isNumber) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    if (!this.enabled) { return; }
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pasted = clipboardData.getData('text');
    if (!/^[0-9]+$/.test(pasted)) {
      event.preventDefault();
    }
  }

  @HostListener('input') onInput() {
    if (!this.enabled) { return; }
    const native = this.el.nativeElement;
    const inputEl: HTMLInputElement | null = (native instanceof HTMLInputElement)
      ? native
      : (native && native.querySelector ? native.querySelector('input') : null);
    if (inputEl) {
      const cleaned = inputEl.value.replace(/\D+/g, '');
      if (cleaned !== inputEl.value) {
        inputEl.value = cleaned;
        inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }
}
